import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const shopApi = axios.create({ baseURL: `${BASE}/api/shop`, withCredentials: true });

shopApi.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("rhm_customer_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export const shopError = (e) => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg).join(" ");
    return e?.message || "Something went wrong";
};
